import React,{useRef,useState,useEffect,useContext} from 'react'
import {UserContext} from '../context/UserContext'
import {Link} from 'react-router-dom'
import {Form,Button,Container,Card,Alert,Table,Modal,Navbar,NavDropdown,Nav,Row,Col,Accordion} from 'react-bootstrap'
//import FileUpload from './FileUpload'
import DataTable from 'react-data-table-component';
import axios from 'axios'
import {FaBookOpen,FaCalendar,} from 'react-icons/fa'
import ChallengeForm from './ChallengeForm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBasketShopping,faEdit,faShop,faPlus,faBaseball,faCheck,faQrcode,faUsers } from '@fortawesome/free-solid-svg-icons'

import ChallengeActiveLight from './ChallengeActiveLight';

export default function Events() {
    const [data,setData]=useState([])
    const [dataFlt,setDataFlt]=useState([])
    const [isLoading,setIsLoading]=useState(false)
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const [record,setRecord]=useState({})
    const [sports,setSports]=useState([])
    const [barcode,setBarcode]=useState('')
    const [person,setPerson]=useState('')
    const [tag,setTag]=useState('')
    const [personUUID,setPersonUUID]=useState('')
    const [scanError,setScanError]=useState(false)
    const [attendees,setAttendees]=useState([])
    const [selSportID,setSelSportID]=useState(0)
    const inputRef = useRef(null);

    const columns = [
        {
            name: '#',
            selector: (row,index) =>  index+1,
            sortable: true,
            maxWidth:'5px'
        },

        {
            name: 'Ενεργό',
            selector: row =>  {
                let yourDate = new Date()
                const today=yourDate.toISOString().split('T')[0]
                const isActive= row.DateTo<=today ? 0 : row.IsActive
                return(
                    <ChallengeActiveLight isActive={isActive} AcceptParticipants={row.AcceptParticipants}/>
                )
                
            },
            sortable: true,
            maxWidth:'10px'
        },

        {
            name: 'Scan',
            selector: row => <Button variant="secondary" onClick={()=>showModal2(row.id)}><FontAwesomeIcon icon={faQrcode}/></Button>,
            sortable: true,
            maxWidth:'5px'
        },
        {
            name: 'Edit',
            selector: row => <Button variant="secondary" onClick={()=>showModal(row.id)}><FontAwesomeIcon icon={faEdit}/></Button>,
            sortable: true,
            maxWidth:'5px'
        },
        {
            name: 'Attendees',
            selector: row => <Button variant="secondary" onClick={()=>showModal3(row.id)}><FontAwesomeIcon icon={faUsers}/></Button>,
            sortable: true,
            maxWidth:'150px'
        },
        {
            name: 'Τίτλος',
            selector: row =>  row.Title,
            sortable: true
        },
        {
          name: 'Τοποθεσία',
          selector: row =>  row.Location,
          sortable: true
      },
        {
          name: 'Sport',
          selector: row =>  row.SportName ,
          sortable: true
      },

        {
          name: 'Έναρξη',
          selector: row =>  row.DateFrom,
          sortable: true,
          maxWidth:'250px'
      }, 
        
        {
            name: 'Λήξη',
            selector: row =>  row.DateTo,
            sortable: true,
            maxWidth:'250px'
        },             
    ]


    const columns2 = [
        {
            name: '#',
            selector: (row,index) =>  index+1,
            sortable: true,
            maxWidth:'5px'
        },

        {
            name: 'Date',
            selector: row =>  row.ScanDate,
            sortable: true
        },
        {
          name: 'Time',
          selector: row =>  row.ScanTime,
          sortable: true
      },
        {
          name: 'Attendee',
          selector: row =>  row.FirstName +' '+row.LastName, 
          sortable: true
      },

      {
        name: 'Category',
        selector: row =>  row.Tag, 
        sortable: true
    }

        
           
    ]


    const columns3 = [
        {
            name: '#',
            selector: (row,index) =>  index+1,
            sortable: true,
            maxWidth:'5px'
        },


        {
          name: 'Attendee',
          selector: row =>  row.FirstName +' '+row.LastName, 
          sortable: true
      },
      
      {
        name: 'Registration Date',
        selector: row =>  row.RegisteredDate, 
        sortable: true
    },

      {
        name: 'Category',
        selector: row =>  row.Tag, 
        sortable: true
    },

    {
        name: '',
        selector: row =>  <Button variant='danger' onClick={()=>unregisterUser(row.UserID,row.EventID)}>X</Button>, 
        sortable: true
    },      
           
    ]

    const unregisterUser=(UserID,EventID)=>{
        if (window.confirm('Unregister User?')){    
            axios.delete(process.env.REACT_APP_API_SERVER+'admin/events/delattendee/'+UserID+'/'+EventID,{
                headers: {
                    'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                    }            
                })
              .then(res=>{
                if (res.data.err==0){
                    showModal3(EventID)
                }
                setShow(false)
                alert(res.data.msg)
            })
        }

    }

    const handleClose = () => {
        setShow(false)
        setPerson('')
        setRecord({ModalTitle:'ΝΕΑ ΕΓΓΡΑΦΗ', id:0,Title:'',IsActive:1,Descr:'',Location:'',DateFrom:'',DateTo:'',SportID:0,Tags:''})
    }
    const handleShow = () => setShow(true);

    const handleClose2 = () => {
        setPersonUUID('')
        setScanError(false)
        setBarcode('')
        setPerson('')
        setShow2(false)
        setRecord({ModalTitle:'ΝΕΑ ΕΓΓΡΑΦΗ', id:0,Title:'',IsActive:1,Descr:'',Location:'',DateFrom:'',DateTo:'',SportID:0,Tags:''})
    }
    const handleShow2 = () => setShow2(true);


    const handleClose3 = () => {
        setPersonUUID('')
        setScanError(false)
        setBarcode('')
        setPerson('')
        setShow3(false)
        setRecord({ModalTitle:'ΝΕΑ ΕΓΓΡΑΦΗ', id:0,Title:'',IsActive:1,Descr:'',Location:'',DateFrom:'',DateTo:'',SportID:0,Tags:''})
    }
    const handleShow3 = () => setShow2(true);


      useEffect(()=>{
        loadData()
        loadSports()
      },[])





      const loadData=()=>{
        setIsLoading(true)
        axios.get(process.env.REACT_APP_API_SERVER+'admin/events',{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
              }            
          })
        .then(res=>{
        //console.log(res.data.results) 
          setData(res.data.results)
          setDataFlt(res.data.results)
          setIsLoading(false)
          
        }).catch(err=>{
            setIsLoading(false)
            console.log(err)
        })          
      }


        const loadSports=()=>{
          setIsLoading(true)
          axios.get(process.env.REACT_APP_API_SERVER+'admin/sports',{
            headers: {
                'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                }            
            })
          .then(res=>{
             // console.log(res.data.results) 
            setSports(res.data.results)
            setIsLoading(false)
            
          }).catch(err=>{
              setIsLoading(false)
              console.log(err)
          })          
        }



    const loadAttendees=(uuid)=>{

        // setIsLoading(true)
        axios.get(process.env.REACT_APP_API_SERVER+'admin/events/attendees/'+uuid+'/1',{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
              }            
          })
        .then(res=>{
            //console.log(res.data.results) 
            setAttendees(res.data.results)
          //setIsLoading(false)
          
        }).catch(err=>{
            setIsLoading(false)
            console.log(err)
        })  
    }

    const loadEventAttendees=(uuid)=>{

        // setIsLoading(true)
        axios.get(process.env.REACT_APP_API_SERVER+'admin/events/attendees/'+uuid+'/0',{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
              }            
          })
        .then(res=>{
            //console.log(res.data.results) 
            setAttendees(res.data.results)
          //setIsLoading(false)
          
        }).catch(err=>{
            setIsLoading(false)
            console.log(err)
        })  
    }


      const showModal=(id)=>{
        if (id==0){
            setRecord({ModalTitle:'ΝΕΑ ΕΓΓΡΑΦΗ', id:0,Title:'',IsActive:1,Descr:'',Location:'',DateFrom:'',DateTo:'',SportID:0,Tags:'',AcceptParticipants:1})
            setShow(true)
        }else{
            const recObj=data.filter(item=>item.id==id)[0]
            
            setRecord({ModalTitle:recObj.Title, id:recObj.id,Title:recObj.Title,Descr:recObj.Descr,Location:recObj.Location,DateFrom:recObj.DateFrom,DateTo:recObj.DateTo,IsActive:recObj.IsActive,SportID:recObj.SportID,Tags:recObj.Tags,AcceptParticipants:recObj.AcceptParticipants})
            //console.log(recObj)
            setShow(true)            
        }
      }

      const showModal2=(id)=>{
            setScanError(false)   
            setBarcode('')
            setPerson('')
            setPersonUUID('')
            const recObj=data.filter(item=>item.id==id)[0]
            
            
            setRecord({ModalTitle:recObj.Title, id:recObj.id,Title:recObj.Title,Descr:recObj.Descr,Location:recObj.Location,DateFrom:recObj.DateFrom,DateTo:recObj.DateTo,IsActive:recObj.IsActive,SportID:recObj.SportID,Tags:recObj.Tags,UUID:recObj.UUID,AcceptParticipants:recObj.AcceptParticipants})
            //console.log(recObj)
            //alert(recObj.UUID)
            loadAttendees(recObj.UUID)
            
            setShow2(true)            


      }


      const showModal3=(id)=>{
        setScanError(false)   
        setBarcode('')
        setPerson('')
        setPersonUUID('')
        const recObj=data.filter(item=>item.id==id)[0]
        
        
        setRecord({ModalTitle:recObj.Title, id:recObj.id,Title:recObj.Title,Descr:recObj.Descr,Location:recObj.Location,DateFrom:recObj.DateFrom,DateTo:recObj.DateTo,IsActive:recObj.IsActive,SportID:recObj.SportID,Tags:recObj.Tags,UUID:recObj.UUID,AcceptParticipants:recObj.AcceptParticipants})
        //console.log(recObj)
        //alert(recObj.UUID)
        loadEventAttendees(recObj.UUID)
        
        setShow3(true)            


  }


      const selectSport=(sportID)=>{
        setSelSportID(sportID)
        if (sportID>0){
            setDataFlt(data.filter(item=>item.SportID==sportID))
        }else{
            setDataFlt(data)
        }
        
      }

      const sportsList=sports.map(item=>{
        return(
          <option key={item.SportID} value={item.SportID}>{item.SportName}</option>
        )
      })      

      const save=(e)=>{   
        e.preventDefault()

        axios.post(process.env.REACT_APP_API_SERVER+'admin/events',record,{
            headers: {
                'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                }            
            })
          .then(res=>{
            if (res.data.err==0){
                loadData()
            }
            setShow(false)
            alert(res.data.msg)
        })
      }

      const deleteRecord=()=>{  
        if (window.confirm('ΔΙΑΓΡΑΦΗ!!!! ΣΙΓΟΥΡΑ???')){
          axios.delete(process.env.REACT_APP_API_SERVER+'admin/events/delevent/'+record.id,{
              headers: {
                  'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                  }            
              })
            .then(res=>{
              if (res.data.err==0){
                  loadData()
              }
              setShow(false)
              alert(res.data.msg)
          })
      }
      }

      const scan=(e)=>{
        e.preventDefault()
        axios.get(process.env.REACT_APP_API_SERVER+'admin/events/scan/'+barcode+'/'+record.UUID,{
            headers: {
                'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                }            
            })
          .then(res=>{
            if (res.data.err==0){
                loadAttendees(record.UUID)
                setPerson(res.data.person)
                setTag(res.data.tag)
                setPersonUUID(res.data.userUUID)
                setBarcode('')
                setScanError(false)
                inputRef.current?.focus()
            }else{
                setScanError(true)
                setPersonUUID('')
                setBarcode('')
                setPerson('')
                inputRef.current?.focus()
            }
            
        })
      }

      const loadImage=(id)=>{
        const d=Date.now()
        //alert(`${process.env.REACT_APP_API_SERVER}files/${userID}/${d}`)
        return(`${process.env.REACT_APP_API_SERVER}files/${id}/${d}`)
      }

      return (
        <>
                {isLoading && 

                <Alert variant="warning" >Loading, please wait....</Alert>
                }

                {!isLoading &&             
                <>
            <Alert variant="secondary">
                <table width="100%">
                    <tr>
                        <td width="150"><h5><FaCalendar/>&nbsp;Events</h5></td>
                        <td width="10"></td>
                        <td align="left">
                        <Form.Control required as="select" value={selSportID} onChange={(e)=>selectSport(e.target.value)} style={{width:'200px'}}>
                                <option value={0}>[All Sports]</option>
                                {sportsList}
                            </Form.Control>

                        </td>
                        <td align="right">
                        <Button variant="dark" onClick={()=>showModal(0)}><FontAwesomeIcon icon={faPlus}/></Button>
                        </td>
                        <td width="10"></td>
                    </tr>
                </table>
                    
            </Alert>
                    <Container fluid>
                    <DataTable
                        columns={columns}
                        data={dataFlt}
                        highlightOnHover
                        //expandableRows
                        //expandableRowsComponent={ExpandedComponent}
                        //pagination
                    />   


                    </Container>    
                </>
          }
        
            <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
                <Modal.Header closeButton>
                <Modal.Title>
                    {record.ModalTitle}
                </Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                <Form onSubmit={save}>

                        <>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Title</Form.Label>
                            <Form.Control type="text" maxLength={250} required value={record.Title} onChange={(e)=>setRecord({...record,Title:e.target.value})}/>
                        </Form.Group>
                        <br/><br/>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Short Description</Form.Label>
                            <Form.Control as="textarea" rows={3} maxLength={2000} value={record.Descr} onChange={(e)=>setRecord({...record,Descr:e.target.value})}/>
                        </Form.Group>                        
                        <br/><br/>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Location</Form.Label>
                            <Form.Control type="text" maxLength={250} required value={record.Location} onChange={(e)=>setRecord({...record,Location:e.target.value})}/>
                        </Form.Group>
                        <br/><br/>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Date From</Form.Label>
                            <Form.Control type="date" required value={record.DateFrom} onChange={(e)=>setRecord({...record,DateFrom:e.target.value})}/>
                        </Form.Group>
                        <br/><br/>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Date To</Form.Label>
                            <Form.Control type="date" required value={record.DateTo} onChange={(e)=>setRecord({...record,DateTo:e.target.value})}/>
                        </Form.Group>
                        <br/><br/>
                        <Form.Group>
                            <Form.Label><b>Sport</b></Form.Label>  
                            <Form.Control required as="select" value={record.SportID} onChange={(e)=>setRecord({...record,SportID:e.target.value})} style={{width:'200px'}}>
                                <option value=''>[Select Sport]</option>
                                {sportsList}
                            </Form.Control>
                        </Form.Group>
                        <br/><br/>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Categories (comma seperated)</Form.Label>
                            <Form.Control type="text" maxLength={250} required value={record.Tags} onChange={(e)=>setRecord({...record,Tags:e.target.value})}/>
                        </Form.Group>
                        <br/><br/>
                        <Form.Group>
                            <Form.Label><b>Ενεργό</b></Form.Label>  
                            <Form.Control as="select" value={record.IsActive} onChange={(e)=>setRecord({...record,IsActive:e.target.value})} style={{width:'200px'}}>
                                <option value='1'>ΝΑΙ</option>
                                <option value='0'>ΟΧΙ</option>
                            </Form.Control>
                        </Form.Group>
                        <br/><br/>
                        <Form.Group>
                            <Form.Label><b>Δέχεται Συμμετοχές</b></Form.Label>  
                            <Form.Control as="select" value={record.AcceptParticipants} onChange={(e)=>setRecord({...record,AcceptParticipants:e.target.value})} style={{width:'200px'}}>
                                <option value='1'>ΝΑΙ</option>
                                <option value='0'>ΟΧΙ</option>
                            </Form.Control>
                        </Form.Group>
                        <br/><br/>
                        <Row><Col></Col>
                        <Col md="auto">

                            {record.id>0 &&
                            <>
                            <Button  variant="danger" style={{width:"150px"}} onClick={deleteRecord}>
                                Διαγραφή
                            </Button>
                            &nbsp; 
                            </>
                            }

                            <Button  variant="success" type="submit" style={{width:"150px"}}>
                                Αποθήκευση
                            </Button>                      
                        </Col>
                      </Row>                        
                        </>
                   </Form> 
                </Modal.Body>

            </Modal>    


            <Modal show={show2} onHide={handleClose2} backdrop="static" size="lg">
                <Modal.Header closeButton>
                <Modal.Title>
                    SCAN {record.ModalTitle} 
                </Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    <Form onSubmit={scan}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>BarCode</Form.Label>
                            <Form.Control type="text" ref={inputRef} autoFocus={true} maxLength={250} required value={barcode} onChange={(e)=>setBarcode(e.target.value)}/>
                        </Form.Group>
                        <br/><br/>
                      
                        <Row><Col></Col>
                            <Col md="auto">

                            <Button  variant="dark" type="submit" style={{width:"150px"}}>
                                Scan
                            </Button>                      
                        </Col>
                      </Row>  
                   </Form> 
                   <hr/>
                   {person.length>0 &&
                    <Alert variant="success">
                        <Row>
                            <Col><h4><FontAwesomeIcon icon={faCheck}/>&nbsp;{person}</h4>{tag}</Col>
                            <Col md="auto"><img src={loadImage(personUUID)} width="60"/></Col>
                        </Row>
                    </Alert>    
                   
                   
                   }
                   {scanError &&
                   
                   
                    <Alert variant="danger" dismissible>Wrong BarCode</Alert>
                    
                    }

                    <hr/>
                    <DataTable
                        columns={columns2}
                        data={attendees}
                        highlightOnHover
                        //expandableRows
                        //expandableRowsComponent={ExpandedComponent}
                        //pagination
                    />   
                </Modal.Body>

            </Modal>      

            <Modal show={show3} onHide={handleClose3} backdrop="static" size="lg">
                <Modal.Header closeButton>
                <Modal.Title>
                    REGISTERED USERS {record.ModalTitle} 
                </Modal.Title>
                </Modal.Header>
                
                <Modal.Body>

                    <DataTable
                        columns={columns3}
                        data={attendees}
                        highlightOnHover
                        //expandableRows
                        //expandableRowsComponent={ExpandedComponent}
                        //pagination
                    />   
                </Modal.Body>

            </Modal>     


        </>
      )
}
